module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("一键分配日志")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 16
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c032565"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sdkControl/incomeAutoLogo.vue
// module id = 1101
// module chunks = 2